import React, { Component } from 'react';
import styled from '@emotion/styled';

import { Theme } from 'ui_system/theme';

export const Container = styled('div')`
  position: absolute;
  display: ${(props) => (props.open ? 'block' : 'none')};
  z-index: 100;
  background-color: white;

  top: 30px;
  left: -10px;

  border: 1px solid ${Theme.colors.lightBorder};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 3px 3px;
`;

export const Option = styled('div')`
  width: 150px;
  font-size: 14px;

  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 15px;
  padding-left: 15px;
  line-height: 1.3;

  &:hover {
    background-color: ${Theme.colors.lightBackground};
  }
`;

class PopoverSelector extends Component {
  selectFilter = (filter) => {
    this.props.selectFilter(filter);
    this.props.closeSelector();
  };

  render() {
    const { dropdownOptions, currentFilter } = this.props;

    return (
      <Container open={this.props.open} data-testid="dropdown-list">
        {dropdownOptions.map((option) => (
          <Option
            data-testid="option"
            key={option.key}
            selected={currentFilter === option.key}
            onClick={() => this.selectFilter(option.key)}
          >
            {option.label}
          </Option>
        ))}
      </Container>
    );
  }
}

export default PopoverSelector;
